import DefaultProductImg from '@/assets/images/placeholder.svg'
import constants from '@/constants'
import { currencyFormatter } from '@/utils/formatter'
import { mapGetters } from 'vuex'
import { postEventMessageToIOS, isIOSAppCheck, isIOSAppParentChildUnsupportedVersion } from '@/utils/common'
import { app } from '@/config'
const { TNC_TYPES } = constants

export default {
  name: 'CommonMixin',
  data () {
    return {
      isLoading: false,
      buttonLoading: false,
      errMsg: ''
    }
  },
  computed: {
    ...mapGetters(['getRegistrationId', 'getUserEmailId', 'getAppConfigs']),
    ...mapGetters('rewardsStore', ['getEngagementInfo']),
    ...mapGetters('orderStore', ['getOrderData']),
    ...mapGetters(['getIsMobile']),
    isIOSApp () {
      return isIOSAppCheck
    },
    isParentChildFeatureEnabled () {
      return this.isIOSApp ? !isIOSAppParentChildUnsupportedVersion : true
    },
    getRegistationPostApiBasicData () {
      return {
        registrationId: this.getRegistrationId,
        email: this.getUserEmailId
      }
    },
    isNewQuotationStatus () {
      return this.getOrderData.status === constants.order.status.QUOTATION_CREATED
    },
    isQuotationWaitingForApprovalStatus () {
      return this.getOrderData.status === constants.order.status.QUOTATION_PROCESSED
    },
    isQuotationRejectedStatus () {
      return this.getOrderData.status === constants.order.status.QUOTATION_REJECTED
    },
    isQuotationExpiredStatus () {
      return this.getOrderData.status === constants.order.status.QUOTATION_EXPIRED
    },
    isQuotationApprovedStatus () {
      return this.getOrderData.status === constants.order.status.QUOTATION_APPROVED || this.getOrderData.status === constants.order.status.PO_CREATED
    },
    isOrderCompletedStatus () {
      return this.getOrderData.status === constants.order.status.ORDER_COMPLETED
    },
    isOrderOnPackingStatus () {
      return this.getOrderData.status === constants.order.status.IN_PACKING
    },
    showLoyaltyFeature () {
      const config = this.getAppConfigs?.loyaltyPoints
      const whitelistedUsers = this.getAppConfigs?.whitelistedUsers || []
      const isFeatureEnabled = config?.isEnabled
      if (!isFeatureEnabled) {
        return false
      }
      const isEnabledOnlyForWhiteListedUser = config.isOnlyForWhitelistedUsers
      if (!isEnabledOnlyForWhiteListedUser) {
        return true
      }
      return whitelistedUsers.includes(this.getUserEmailId)
    },
    showMissionFeature () {
      return this.getAppConfigs?.mission?.isEnabled || false
    },
    activePoints () {
      return this.getEngagementInfo?.memberLoyaltyResponse?.activePoint || 0
    },
    formattedActivePoints () {
      return this.activePoints ? currencyFormatter(this.activePoints, { showZero: true, showSymbol: false }) : 0
    }
  },
  methods: {
    postMessageToIOS: postEventMessageToIOS,
    getPaymentMethodSelectedOption (option) {
      return { text: option?.label || '', value: option?.dbValue || '' }
    },
    showRegistrationLoading () {
      this.isLoading = true
    },
    hideRegistrationLoading () {
      this.isLoading = false
    },
    showBtnLoading () {
      this.buttonLoading = true
    },
    hideBtnLoading () {
      this.buttonLoading = false
    },
    defaultApiFailure (res) {
      this.isLoading = false
      this.buttonLoading = false

      const errorCode = res.errorCode
      let tempMsg = this.$t(`ERRORS.COMMON.${errorCode}`)
      if (tempMsg === `ERRORS.COMMON.${errorCode}`) {
        this.errMsg = this.$t('ERRORS.COMMON.SYSTEM_ERROR')
      } else {
        this.errMsg = this.$t(`ERRORS.COMMON.${errorCode}`)
      }
    },
    handleClearUserData () {
      this.$store.commit('setShowLoader', true)
      this.showCloseFormModalStatus = false
      this.$store.dispatch('LOGOUT_USER', {
        success: this.logoutApiSuccess
      })
    },
    logoutApiSuccess () {
      if (this.isIOSApp) {
        this.postMessageToIOSListener('LOGGED_OUT')
      }
    },
    allowOnlyNumbers (e) {
      e.returnValue = e.keyCode >= 48 && e.keyCode <= 57
    },
    onPaste (evt) {
      const reg = /^\d+$/
      const data = evt.clipboardData.getData('Text')
      if (!(reg.test(data))) {
        evt.preventDefault()
      }
    },
    displayFallBackProductImg (e) {
      e.target.src = DefaultProductImg
    },
    convertEmptyStringsToNull (obj) {
      if (Array.isArray(obj)) {
        return obj.map(item => this.convertEmptyStringsToNull(item))
      } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
          const value = typeof obj[key] === 'string' ? obj[key].trim() : obj[key]
          // eslint-disable-next-line no-useless-escape
          acc[key] = (value === '' || value === '\"\"') ? null : this.convertEmptyStringsToNull(value)
          return acc
        }, {})
      } else {
        return obj
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    formatDate (date) {
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()

      return `${day}-${month}-${year}`
    },
    viewPrivacyPolicy () {
      const privacyPolicyURL = this.getAppConfigs?.privacyPolicyURL
      if (this.isIOSApp) {
        this.postMessageToIOS('iosPrivacyPolicyListener', { privacyPolicyURL })
        return
      }
      window.open(privacyPolicyURL, '_blank')
    },
    viewTermsAndConditions (isRegistrationFlow = false) {
      const routeConfig = {
        name: app.routerName.termsAndCondition,
        query: isRegistrationFlow ? { type: TNC_TYPES.REGISTRATION } : {}
      }
      if (this.getIsMobile) {
        this.$router.push(routeConfig)
      } else {
        const tncRoute = this.$router.resolve(routeConfig)
        window.open(tncRoute.href, '_blank')
      }
    },
    viewTickerURL (url, isDocument, target = '_blank') {
      if (isDocument) {
        if (this.isIOSApp) {
          this.postMessageToIOS('iosTermsAndConditionsListener', { termsAndConditionsURL: url })
        } else {
          window.open(url, target)
        }
      } else if (this.isIOSApp && url === 'rewards') {
        this.postMessageToIOS('iosListener', 'OPEN_SCAN_IMEI')
        this.$router.push({ name: url })
      } else {
        this.$router.push({ name: url })
      }
    },
    postMessageToIOSListener (message) {
      window.webkit?.messageHandlers?.iosListener?.postMessage(message)
    },
    postMessageToIOSLoginListener (message) {
      window.webkit?.messageHandlers?.iosLoginListener?.postMessage(message)
    },
    postMessageToIOSDownloadListener (downloadInfo) {
      window.webkit?.messageHandlers?.iosDownloadListener?.postMessage(downloadInfo)
    },
    handleCopyClipboard (value, toastMsg) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(value).then(() => {
          this.showToast(toastMsg)
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.showToast(this.$t('orderDetail.clipboardNotSupported'))
      }
    },
    showToast (message, type = '', duration = 3000) {
      this.$toast.open({
        message,
        type,
        duration
      })
    }
  }
}
